import { Input as MUIInput, InputAdornment } from '@mui/material';
import React, { ChangeEvent } from 'react';
import clsx from 'clsx';

type Props = {
    placeholder: string;
    required?: boolean;
    icon?: string;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    className?: string;
};

export default function Input({ icon, className, ...props }: Props) {
    return (
        // TODO: replace by NInput
        <MUIInput
            {...props}
            startAdornment={
                icon && (
                    <InputAdornment position="start">
                        <img
                            className="mx-auto h-24 w-24"
                            src={icon}
                            alt="DH-logo"
                        />
                    </InputAdornment>
                )
            }
            className={clsx(
                'px-16 py-12 bg-faded-blue-100 font-light !text-sm !text-faded-blue-600',
                className,
            )}
        />
    );
}
